export default "__VITE_ASSET__w3ef9cDA__"